module.exports = __webpack_public_path__ + "static/img/2.bc3b641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpitCh/2.png
// module id = k+jX
// module chunks = 31